import { render } from "./LandingForm.vue?vue&type=template&id=10f57429&scoped=true&ts=true&lang=pug"
import script from "./LandingForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandingForm.vue?vue&type=script&lang=ts&setup=true"

import "./LandingForm.vue?vue&type=style&index=0&id=10f57429&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f57429"]])

export default __exports__